import * as React from 'react';
import { BaseEditItem, useDispatchGPE, useSelectorGPE } from '../GeneralPostEdit';
import * as _ from "lodash";
import { GeneralPostEditActions } from '../GeneralPostEditStateHandling';
import { getPath } from 'services/Helpers';

export const useGPEState = <S extends BaseEditItem = BaseEditItem, T extends any = any>(getter: (item: S) => T): {
    value: T,
    setValue: (val: T | ((val: T) => T)) => void,
    addFile: (lng?: string, selectMediaForLng?: string[]) => void,
    addFileTo: (nameStack: string[], lng?: string, selectMediaForLng?: string[]) => void,
    resetValue: () => void,
    originalValue: T,
} => {
    const nameStack = React.useMemo(() => getPath(getter as any), [getter]);
    //console.log('nameStack => ', nameStack);
    // console.log('getter.toString() => ', getter.toString());
    const post = useSelectorGPE(s => s.post);
    const originalPost = useSelectorGPE(s => s.originalPost);
    const d = useDispatchGPE();
    const setValue = React.useMemo(() => (val: T | ((val: T) => T)) => d(GeneralPostEditActions.setValue(nameStack, val)), [nameStack, d]);
    const value = React.useMemo(() => {
        let cur: any = post;
        _.forEach(nameStack, ns => {
            cur = (cur as any)[ns];
        });
        return cur as T;
    }, [post, nameStack]);
    const originalValue = React.useMemo(() => {
        let cur: any = originalPost;
        _.forEach(nameStack, ns => {
            cur = (cur as any)[ns];
        });
        return cur as T;
    }, [originalPost, nameStack]);

    const addFile = React.useMemo(() => (lng?: string, selectMediaForLng?: string[]) => {
        d(GeneralPostEditActions.addFile(nameStack, lng, selectMediaForLng));
    }, [d, nameStack]);
    const addFileTo = React.useMemo(() => (ns: string[], lng?: string, selectMediaForLng?: string[]) => {
        d(GeneralPostEditActions.addFile([...nameStack, ...ns], lng, selectMediaForLng));
    }, [d, nameStack]);
    const resetValue = React.useMemo(() => () => {
        d(GeneralPostEditActions.resetValue(nameStack));
    }, [nameStack, d]);
    return { value, setValue, addFile, addFileTo, resetValue, originalValue };
};